import { render } from "./ViewProgressSpinner.vue?vue&type=template&id=97edb390&scoped=true&ts=true"
import script from "./ViewProgressSpinner.vue?vue&type=script&lang=ts"
export * from "./ViewProgressSpinner.vue?vue&type=script&lang=ts"

import "./ViewProgressSpinner.vue?vue&type=style&index=0&id=97edb390&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97edb390"]])

export default __exports__